import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const INITIAL_STATE = {
  isBlocked: false,
  isCheckModalBlocked: false,
  lastAllowedPath: "",
  blockedPath: "",
  blockedPaths: [],
  isModalOpen: false,
  customModalTrigger: false,
  isCustomModalOpen: false,
  onLeaveFunction: null,
  modalName: "",
  companyAndFinancialYearSwitch: {
    isPending: false,
    targetCompanyId: null,
    targetFinancialYearId: null,
    triggeredFromPath: "/",
    isCompanySwitch: false,
    isFinancialYearSwitch: false,
    message: "",
  },
};

const controllNavigationSlice = createSlice({
  name: "controlNavigation",
  initialState: INITIAL_STATE,
  reducers: {
    setNavigationBlocked(state, action) {
      state.isBlocked = action.payload;
    },
    setModalBlocked(state, action) {
      state.isCheckModalBlocked = action.payload;
    },
    setCompanyAndFinancialYearSwitchDetails(state, action) {
      const {
        isPending,
        targetCompanyId,
        targetFinancialYearId,
        isCompanySwitch,
        isFinancialYearSwitch,
        message,
      } = action.payload;
      state.companyAndFinancialYearSwitch = {
        isPending,
        targetCompanyId,
        targetFinancialYearId,
        isCompanySwitch,
        isFinancialYearSwitch,
        triggeredFromPath:
          state.companyAndFinancialYearSwitch.triggeredFromPath,
        message,
      };
    },
    setBlockedPath(state, action) {
      state.blockedPath = action.payload;
    },
    setModalOpen(state, action) {
      state.isModalOpen = action.payload;
    },
    setLastAllowedPath(state, action) {
      state.lastAllowedPath = action.payload;
    },
    setCustomModalAction(state, action) {
      const { key, value } = action.payload;
      state[key] = value;
    },

    resetNavigationState: () => INITIAL_STATE,
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE);
  },
});

export const {
  setNavigationBlocked,
  setModalBlocked,
  setBlockedPath,
  setModalOpen,
  setLastAllowedPath,
  setCustomModalAction,
  resetNavigationState,
  setCompanyAndFinancialYearSwitchDetails,
} = controllNavigationSlice.actions;

export default controllNavigationSlice.reducer;
